import { format } from "date-fns";

/* Assign the appropriate font-awesome icon clss based on file extension/file name */
export const getFileIconFromName = (name = "") => {
  const extension = name.split(".").pop()?.toLowerCase();

  switch (true) {
    case extension === "pdf":
      return { icon: "fas fa-file-pdf" };

    case ["jpg", "jpeg", "png", "gif", "bmp", "tif"].includes(extension):
      return { icon: "fas fa-file-image" };

    case ["mp4", "avi", "mov", "wmv"].includes(extension):
      return { icon: "fas fa-file-video" };

    case ["doc", "docx"].includes(extension):
      return { icon: "fas fa-file-word" };

    case ["xls", "xlsx"].includes(extension):
      return { icon: "fas fa-file-excel" };

    case ["ppt", "pptx"].includes(extension):
      return { icon: "fas fa-file-powerpoint" };

    default:
      return { icon: "fas fa-file-alt" };
  }
};

/* Returns file type label */
export const getFileTypeFromName = (name = "") => {
  const extension = name.split(".").pop()?.toLowerCase();

  if (extension === "pdf") return "Pdf";

  if (["jpg", "jpeg", "png", "gif", "bmp", "tif"].includes(extension))
    return "Image";

  if (["mp4", "avi", "mov", "wmv"].includes(extension)) return "Video";

  if (["doc", "docx"].includes(extension)) return "Word";

  if (["xls", "xlsx"].includes(extension)) return "Excel";

  if (["ppt", "pptx"].includes(extension)) return "PowerPoint";

  return "OTHER";
};

/* Standardize and parse date /time formatting for document objects in gui */
export const formatFileDateTime = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return (
    `\n${format(date, "MM/dd/yyyy")}\n` +
    `at\n` +
    `${format(date, "hh:mm:ss a")}`
  );
};
